import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { addMonths, getYear, isEqual } from 'date-fns';
import { getUTCEndOfMonth } from '@vendasta/galaxy/utility/date-utils';
import { PotentialRevenueService } from '../potential-revenue.service';
import { RevenueSelectorChoice } from './revenue-date-dropdown.component.interfaces';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { getLocale } from '@vendasta/galaxy/utility/locale';
import { formatInTimeZone } from 'date-fns-tz';

const MAX_MONTHS_TO_DISPLAY = 6;

@Component({
  selector: 'sales-ui-revenue-date-selector',
  templateUrl: './revenue-date-selector.component.html',
  styleUrls: ['./revenue-date-selector.component.scss'],
  standalone: false,
})
export class RevenueDateSelectorComponent implements OnInit {
  monthYearRevenueFilterList: RevenueSelectorChoice[];
  currentSelection$: Observable<RevenueSelectorChoice>;

  private readonly initialSelection = <RevenueSelectorChoice>{
    monthYear: null,
    displayString: this.translate.stream('FRONTEND.SALES_UI.PIPELINE.REVENUE_FOR_DATE_PERIOD', {
      date: getYear(new Date()),
    }),
  };

  constructor(
    private readonly translate: TranslateService,
    private readonly revenueDateService: PotentialRevenueService,
  ) {}

  ngOnInit(): void {
    this.monthYearRevenueFilterList = this.generateMonthYearRevenueList();

    this.currentSelection$ = this.revenueDateService.selectedDate$.pipe(
      map((d) => {
        if (d === <Date>null) {
          return this.initialSelection;
        }

        return this.monthYearRevenueFilterList.find((m) => isEqual(m.monthYear, d));
      }),
    );
  }

  changeDate($event: RevenueSelectorChoice): void {
    this.revenueDateService.setDate($event.monthYear);
  }

  private generateMonthYearRevenueList(): RevenueSelectorChoice[] {
    const options = [this.initialSelection];

    for (let i = 0; i < MAX_MONTHS_TO_DISPLAY; i++) {
      const temp = getUTCEndOfMonth(addMonths(new Date(), i));
      options.push(<RevenueSelectorChoice>{
        monthYear: temp,
        displayString: of(formatInTimeZone(temp, 'UTC', 'MMMM yyyy', { locale: getLocale() })),
      });
    }

    return options;
  }
}
